export default __webpack_public_path__ + "static/media/Brasil-bandeira.2f9c54e9.svg";